<template>
  <div>
    <h1>Tömeges feltöltés fájlból</h1>
    <div class="column-flex-container">
      <div>
        <b-form-file
          v-model="fileToUpload"
          class="upload-input"
          ref="file-input"
          accept=".json"
          :state="fileSizeOk"
          placeholder="Nincs fájl kiválasztva"
          browse-text="Kiválasztás"
        ></b-form-file>
        <b-form-invalid-feedback
          class="feedback"
          :state="fileSizeOk"
        >A fájl nem lehet nagyobb {{ (maxSize / 1000).toFixed(2) }}kB-nál</b-form-invalid-feedback>
        <b-form-valid-feedback
          class="feedback"
          :state="fileSizeOk"
        >A fájl mérete {{ fileToUpload ? (fileToUpload.size / 1000).toFixed(2) : undefined }} kB</b-form-valid-feedback>
      </div>
      <b-button @click="uploadFile(isTest=true)" :disabled="!Boolean(fileSizeOk)" variant="info" class="upload-button">
        Teszt Feltöltés
        <v-icon class="upload-icon" scale="2" name="cloud-upload-alt" />
      </b-button>
      <b-button @click="uploadFile(isTest=false)" :disabled="!Boolean(fileSizeOk)" variant="success" class="upload-button">
        Feltöltés
        <v-icon class="upload-icon" scale="2" name="cloud-upload-alt" />
      </b-button>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons/cloud-upload-alt"
import Icon from "vue-awesome/components/Icon"
import { uploadContent } from "../services/backendService"

export default {
  name: "BulkUpload",
  components: {
    "v-icon": Icon
  },
  data() {
    return {
      fileToUpload: null,
      maxSize: 100000000 // ~100 MB
    }
  },
  computed: {
    fileSizeOk() {
      return this.fileToUpload ? this.fileToUpload.size < this.maxSize : null
    }
  },
  methods: {
    readFile(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()

        reader.onload = () => {
          resolve(reader.result)
        }

        reader.onerror = reject

        reader.readAsText(file)
      })
    },
    clearFileInput() {
      this.$refs["file-input"].reset()
    },
    async uploadFile(isTest=false) {
      try {
        let content = await this.readFile(this.fileToUpload)
        let response = await uploadContent(content, isTest)
        alert("Fájl sikeresen feltöltve")
      } catch (err) {
        if (err.response.status == 400) {
          alert("A feltöltött fájl nem megfelelő JSON")
        }
      } finally {
        this.clearFileInput()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  text-align: center !important;
}
.feedback {
  text-align: start;
  margin-left: 5px;
  margin: 0.25rem;
  width: auto;
}
.column-flex-container {
  justify-content: space-between;
}
.upload-input {
  width: 400px;
  text-align: start;
}

.upload-button {
  margin-top: 12px;
  width: 400px;
  font-weight: bold;
  font-size: 20px;
  vertical-align: middle;
}

.upload-icon {
  margin-left: 5px;
  margin-bottom: 5px;
}
</style>
